import { Link } from 'react-router-dom';

import { Card, Empty } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="page">
      <Card>
        <Empty
          icon="?"
          title="Page not found"
          actions={
            <Link className="btn" to="/">
              Go to Overview
            </Link>
          }
        />
      </Card>
    </div>
  );
}
